const care = {
  residentCare: {
    hero: {
      eyebrow: "A second home",
      title: "Resident Care",
      subtitle: "A loving home — not an institution.",
    },
    items: {
      comfortableStay: {
        title: "Comfortable Stay",
        desc: "Clean, well-ventilated rooms with attendants on every floor.",
      },
      nutritiousMeals: {
        title: "Nutritious Meals",
        desc: "Three meals + tea, prepared to suit elderly dietary needs.",
      },
      medicalCare: {
        title: "Medical Care",
        desc: "Daily medicines, 24×7 doctors, hospital tie-ups.",
      },
      companionship: {
        title: "Companionship",
        desc: "Group activities, satsang, festivals and birthday celebrations.",
      },
      emotionalSupport: {
        title: "Emotional Support",
        desc: "Counseling, family video calls and one-to-one care.",
      },
      ritualsDignity: {
        title: "Rituals & Dignity",
        desc: "Punya Tithi, last rites and remembrance — performed with respect.",
      },
    },
    form: {
      eyebrow: "Apply for Admission",
      heading: "Resident Admission Enquiry",
      description:
        "Please share complete details of the elder seeking admission. Our admission team will get in touch within 1–2 working days.",
      select: "Select…",
      submit: "Submit Admission Enquiry",
      submitting: "Submitting...",
      sections: {
        resident: "Resident Details",
        health: "Health & Mobility",
        admission: "Admission Details",
        applicant: "Applicant / Family Contact",
      },
      labels: {
        residentName: "Resident Full Name *",
        gender: "Gender",
        dob: "Date of Birth",
        bloodGroup: "Blood Group",
        maritalStatus: "Marital Status",
        religion: "Religion",
        jainStatus: "Jain Status",
        caste: "Caste / Community",
        education: "Education",
        occupation: "Past Occupation",
        residentMobile: "Resident Mobile",
        aadhaar: "Aadhaar Number",
        identificationMark: "Identification Mark",
        previousAddress: "Previous Address",
        city: "City",
        state: "State",
        pincode: "Pincode",
        healthConditions: "Existing Health Conditions",
        currentMedications: "Current Medications",
        mobility: "Mobility",
        admissionType: "Admission Type",
        monthlyMaintenance: "Monthly Maintenance Budget (₹)",
        preferredDate: "Preferred Admission Date",
        referredBy: "Referred By",
        reason: "Reason for Admission *",
        applicantName: "Applicant Name *",
        relation: "Relation to Resident",
        mobile: "Mobile *",
        altMobile: "Alt Mobile",
        email: "Email",
        applicantAddress: "Applicant Address",
        emergencyName: "Emergency Contact Name",
        emergencyMobile: "Emergency Mobile",
        emergencyRelation: "Emergency Relation",
        notes: "Additional Notes",
      },
      placeholders: {
        bloodGroup: "e.g. B+",
        healthConditions: "Diabetes, BP, joint pain, etc.",
        relation: "Son / Daughter / Nephew…",
      },
      options: {
        gender: {
          male: "Male",
          female: "Female",
          other: "Other",
        },
        marital: {
          single: "Single",
          married: "Married",
          widowed: "Widowed",
          divorced: "Divorced",
        },
        jain: {
          shwetambar: "Shwetambar",
          digambar: "Digambar",
          sthanakvasi: "Sthanakvasi",
          terapanthi: "Terapanthi",
          other: "Other",
        },
        mobility: {
          independent: "Independent",
          walkingStick: "Walking stick",
          walker: "Walker",
          wheelchair: "Wheelchair",
          bedRidden: "Bed-ridden",
        },
        admission: {
          free: "Free",
          paid: "Paid",
          subsidised: "Subsidised",
        },
      },
    },
    toast: {
      error: "Could not submit.",
      success:
        "Enquiry received. Our admission team will call within 1–2 working days.",
    },
  },

  healthcare: {
    hero: {
      eyebrow: "BHAGWAN MAHAVIR HEALTHCARE INITIATIVE",
      title: "Bhagwan Mahavir Healthcare Services",
      subtitle:
        "Comprehensive medical care, eye care hospital, dental clinic, and Gujarat's 1st Vruddhashram rehabilitation center — serving senior citizens and the community with dedication.",
      exploreBtn: "Explore Healthcare Units",
      donateBtn: "Support & Donate",
    },
    about: {
      eyebrow: "ABOUT THE INITIATIVE",
      title: "About Healthcare Services",
      tagline:
        "Dedicated medical care, state-of-the-art clinics, and compassionate healing for senior citizens and the needy.",
      body:
        "Bhagwan Mahavir Healthcare Services at Jivandhara Vruddhashram provide holistic medical facilities, including a 24x7 general physician, the Bhagwan Mahavir Eye Care Hospital, an advanced dental clinic, and Gujarat's 1st Vruddhashram Physiotherapy & Rehabilitation Center. All services are dedicated to ensuring the health, dignity, and vitality of our elderly residents and surrounding communities.",
      exploreBtn: "Explore Healthcare Units",
      donateBtn: "Support & Donate",
    },
    units: {
      eyebrow: "On-Campus Medical Centers",
      title: "Select a Healthcare Unit",
      subtitle:
        "Click on any section below to view its complete medical services, doctors, equipment, and highlights.",
      emptyTitle: "No Healthcare Units Registered",
      emptyDesc: "Please check back later or set up units in the admin panel.",
      clickToView: "Click to view details",
      defaultBadge: "Care Services",
    },
    stats: {
      eyebrow: "❋ TRUSTED HEALTHCARE IMPACT ACROSS GUJARAT ❋",
      cataract: "Monthly Cataract Surgeries",
      eyeOpd: "Daily Eye OPD Patients",
      dentalOpd: "Monthly Dental OPD Patients",
      physioIpd: "Daily Physiotherapy IPD Sessions",
      eyeCamps: "Free Rural Eye Check-up Camps",
    },
    contact: {
      inchargeLabel: "Medical In-charge:",
      helplineLabel: "24/7 Emergency Helpline:",
      defaultIncharge: "Sejal Shah (Chief Coordinator)",
    },
    sevaYajna: {
      badge: "A Sacred Seva Yagna... Keeping Humanity Alive",
      centerName: "Bhagwan Mahavir Medical Centre",
      address:
        "Jivandhara Old Age Home, Padmavati Nagar, Indiranagar Vibhag-2, Lambha, Ahmedabad - 382405",
      title: "A Sacred Seva Yagna... Keeping Humanity Alive",
      p1:
        "We all know how expensive healthcare has become in today's demanding times. For an ordinary person, even paying a doctor's consultation fee is challenging—one can only imagine the plight of economically vulnerable families.",
      p2:
        "Understanding this deep pain, Jivandhara Vruddhashram has been operating at Lambha, Ahmedabad since 2002, where today more than 298 destitute elders find shelter, food, medicine, and dignity.",
      p3:
        "To ensure timely and comprehensive healthcare for these resident elders and thousands of needy villagers in and around Lambha, the trust established Bhagwan Mahavir Medical Centre in 2011.",
      servicesHeading:
        "Over the years, this service expanded rapidly. Today, the trust actively operates the following full-fledged medical wings:",
      services: [
        "Bhagwan Mahavir Eye Care Hospital",
        "Bhagwan Mahavir Dental Clinic",
        "Bhagwan Mahavir Physiotherapy Centre",
        "Paralysis Rehabilitation Centre",
        "24x7 Emergency Ambulance Service",
      ],
      freeCareNote:
        "All these services are 100% completely free of cost for the elderly residents of Jivandhara Vruddhashram, while other underprivileged patients from surrounding villages are served at nominal token rates. Thousands of patients benefit every month.",
      expenseNote:
        "The trust incurs lakhs of rupees in expenses every month to keep this noble healthcare mission running. Your partnership in this sacred endeavor is the truest service to humanity.",
      joinAppeal:
        "We warmly invite you to partner with us in this holy mission and earn spiritual merit through your generous support.",
    },
    schemes: {
      eyebrow: "SPONSORSHIP & MAINTENANCE PLANS",
      title: "Bhagwan Mahavir Medical Centre – Maintenance Schemes",
      subtitle:
        "Participate in our medical sponsorship programs to provide lifeline treatments, daily medicines, and specialist care to destitute elders.",
      pillarTitle: "Major Pillar & Long-Term Support Schemes",
      regularTitle: "General & Regular Medical Seva Schemes",
      sponsorBtn: "Sponsor Now",
      items: {
        mainPillar: "Main Pillar Support",
        coPillar: "Co-Pillar Support",
        lifetimeTithi: "Lifetime Tithi Support",
        tenYearTithi: "10 Years Tithi Support",
        generalDaily: "1 Day General Medical Support (All)",
        monthly: "Monthly Medical Maintenance",
        oneDay: "1 Day Medical Support",
        elderMedicalAid: "Elder Medical Aid",
        elderDiaper: "Elder Diaper Scheme",
      },
    },
    appeal: {
      quote:
        "“With your small contribution, an elderly father will receive timely medicine, and a mother's eyes will regain vision. We humbly appeal for your generous support.”",
      taxExemptTitle: "100% Tax Exemption & CSR",
      taxExemptDesc:
        "All donations made to the trust are 100% Tax Exempt under Section 80G of the Income Tax Act. CSR (Corporate Social Responsibility) funding is gladly accepted.",
      helplineTitle: "Direct Contact Numbers:",
      motto: "“Service to Humanity is Service to God” — Come, let us join this sacred mission.",
    },
  },

  elderCare: {
    hero: {
      eyebrow: "Elder Care",
      title: "Lifetime care, with dignity",
      subtitle:
        "Shelter, food, medicine, companionship and rituals — provided with the warmth of family, never as pity.",
    },
    impact: {
      residentsCared: "Residents Cared For",
      lifetimeCare: "Of Lifetime Care",
      lastRites: "Dignified Last Rites",
      donorFunded: "Donor Funded",
    },
    overview: {
      eyebrow: "Program Overview",
      heading: "Care that goes beyond a room and a meal",
      description:
        "Every resident receives the same standard of care — whether they came to us with means or with nothing at all.",
    },
    services: {
      shelter: {
        title: "Lifetime Shelter",
        body: "A clean, safe room and a place at the family table — for as long as our elders need it, at no cost.",
      },
      bhojan: {
        title: "Daily Bhojan Seva",
        body: "Three nutritious, freshly cooked Jain-style meals every day, planned with dietary needs in mind.",
      },
      care: {
        title: "Round-the-Clock Care",
        body: "Trained caretakers, daily doctor rounds, and 24×7  doctors, medical treatment, nursing, and ambulance service for residents who need assistance.",
      },
      dignity: {
        title: "Dignity & Rituals",
        body: "Birthdays, festivals and last rites are observed with the same care a family would offer.",
      },
      physio: {
        title: "1st in Gujarat - Paralysis Rehabilitation Physiotherapy Center",
        body: "Gujarat's 1st old age home paralysis rehabilitation & physiotherapy center dedicated to elderly recovery and mobility.",
      },
    },
    facilities: {
      imgAlt: "Residents enjoying a shared meal",
      eyebrow: "Facilities & Services",
      heading: "A home built around our elders",
      description:
        "Designed with mobility, safety and community in mind — where every corner has love and warmth.",
      items: {
        capacity: "360+ resident capacity across A, B and C blocks",
        clinic: "In-house clinic with daily nursing rounds",
        physio: "Physiotherapy & yoga room",
        library: "Library, prayer hall and satsang space",
        access: "Wheelchair-friendly access throughout",
        garden: "Garden, walking paths and outdoor seating",
        entertainment: "Entertainment hall, Movie hall: Library, prayer hall and satsang space",
      },
    },
    stories: {
      eyebrow: "Impact Stories",
      heading: "Echoes of our parivaar",
      items: {
        kantilal: {
          name: "Kantilal Bhai",
          years: "12 years with us",
          quote: "I came alone. I have a family now — 119 brothers and sisters.",
        },
        saroj: {
          name: "Saroj Ben",
          years: "5 years with us",
          quote:
            "Every birthday since I came here has had a cake. I had forgotten what that felt like.",
        },
        hasmukh: {
          name: "Hasmukh Bhai",
          years: "9 years with us",
          quote:
            "When I fell ill, the doctor came at midnight. Where else would that happen?",
        },
      },
    },
    gallery: {
      eyebrow: "Photo Gallery",
      heading: "Love-filled moments from our home",
      viewFull: "View Full Gallery",
      items: {
        care: "Compassionate Care",
        meals: "Shared Meals",
        health: "Daily Health Checks",
      },
    },
    cta: {
      tagline: "We Need Our Parents",
      heading: "Sponsor an Elder's Care",
      description:
        "Your support funds shelter, meals and medicine for the elders of Jivandhara Old Age Home.",
      support: "Support Elder Care",
      visit: "Visit the Home",
    },
  },
};

export default care;
